export default __webpack_public_path__ + "static/secure-9fc27f079d21957c969ec79796f8612d.png";